import { Col, Divider, Row } from 'antd'
import Avatar from 'components/Avatar'
import CalenderIcon from 'components/icons/CalendarIcon'
import CarIcon from 'components/icons/CarIcon'
import LocationMarkIcon from 'components/icons/LocationMarkIcon'
import NoteListIcon from 'components/icons/NoteListIcon'
import InfoCards from 'components/InfoCards'
import DriveStatus from 'modules/Drive/Partials/DrivesInfoTable/Partials/DriveStatus'
import {
  BoldText,
  CardDriveRow,
  CardRowDrive,
  CompanyDriveInfoName,
  DomainDriveInfoName,
  ItemsFlex,
  LightText,
  LocationText,
  ModeText,
} from 'modules/DriveInfo/Styles/style'
import moment from 'moment'
import React from 'react'
import { COLORS } from 'theme'

const DriveInfoDetails = ({
  infoDrawer,
  setInfoDrawer,
  onCancelDrawer,
  onScheduleDrawer,
  selectedDrive,
  setIsReschedule,
  selectedDriveInfo,
  cardsData,
  ViewDriveList,
  id,
}) => {
  const popupData = ViewDriveList?.details?.[0]

  return (
    <React.Fragment>
      <CardRowDrive>
        <Avatar
          background
          src={''}
          size={56}
          IconName={selectedDrive?.corporate?.name?.split('')[0]}
          font={18}
        />
        <CompanyDriveInfoName>
          {selectedDrive?.corporate?.name}
        </CompanyDriveInfoName>
        <DomainDriveInfoName>
          {selectedDrive?.corporate?.industry}
        </DomainDriveInfoName>
      </CardRowDrive>
      <Divider type="horizontal" />
      <Row style={{ marginBottom: 10 }}>
        <Col span={12} style={{ marginBottom: 10 }}>
          <ItemsFlex>
            <LightText>
              <CalenderIcon />
              Date
            </LightText>
            <BoldText>
              {moment(selectedDrive?.startDate).format('DD/MM/YYYY')} -{' '}
              {moment(selectedDrive?.endDate).format('DD/MM/YYYY')}
            </BoldText>
          </ItemsFlex>
          <ItemsFlex>
            <LightText>
              <CarIcon />
              Drive Mode
            </LightText>
            <ModeText>
              {popupData?.driveMode?.replace('_', '  ').toLowerCase()}
            </ModeText>
          </ItemsFlex>
          <ItemsFlex>
            <LightText>
              <NoteListIcon />
              Drive Status
            </LightText>
            <BoldText>
              <DriveStatus
                status={
                  selectedDrive?.driveMode === 'VIRTUAL_DRIVE'
                    ? selectedDrive?.virtualDriveInstituteCampusMap?.[0]
                        ?.instituteStatus
                    : selectedDrive?.instituteStatus
                }
                bordered={true}
              />
            </BoldText>
          </ItemsFlex>
          {selectedDrive?.driveMode !== 'VIRTUAL_DRIVE' ? (
            <ItemsFlex>
              <LightText>
                <LocationMarkIcon />
                Drive Location
              </LightText>
            </ItemsFlex>
          ) : null}
          <BoldText>{popupData?.hostCollegeName}</BoldText>
          <LocationText>{popupData?.city}</LocationText>
        </Col>
        <Col span={12}>
          <CardDriveRow spaceBetween style={{ gap: '15px' }}>
            {cardsData?.map(card => (
              <InfoCards
                key={card?.key}
                width={'13em'}
                icon={card?.icon}
                text={card?.text}
                value={card?.value}
                background={
                  card?.isSelected ? COLORS.BLUE_T_50 : COLORS.BLUE_T_95
                }
                isSelected={card?.isSelected}
                onClick={() => {
                  applyCardFilter(card)
                }}
              />
            ))}
          </CardDriveRow>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default DriveInfoDetails
